<!-- <!DOCTYPE html>
<html lang="en"> -->
<!-- 
<head>
    <meta charset="UTF-8">
    <title>Modern Web Design</title>
    <meta name="viewport" content="width=device-width, initial-scale=1">

    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">

    <link href="./style.css" rel="stylesheet">

    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css">
</head> -->

<!-- <body> -->

<!-- Navbar -->
<!-- <nav class="navbar navbar-expand-lg navbar-dark position-absolute w-100 my-lg-4">
   
    <div class="container">

        <a class="navbar-brand fw-bold" href="#">
            <img src="/assets/images/NeoJobz_192_192-1.svg" width="200" height="50" alt="">
        </a>
        <button class="navbar-toggler " type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse nav-cutom-menu pb-3" id="navbarNav">
            <ul class="navbar-nav align-items-center justify-content-center">
                <li class="nav-item"><a class="nav-link" href="#">Home</a></li>
                <li class="nav-item"><a class="nav-link" (click)="goTo('/about-us')">About</a></li>
                <li class="nav-item"><a class="nav-link" (click)="goTo('/our-services')">Services</a></li>
                <li class="nav-item"><a class="nav-link " (click)="goTo('/products')">Pricing</a></li>
                <li class="nav-item"><a class="nav-link" (click)="goTo('/job-finder')">Jobs</a></li>
                <li class="nav-item"><a class="nav-link" (click)="goTo('/contact-us')">Contact</a></li>
            </ul>

            <a class="btn btn-gradient" (click)="goTo('/sign-in')">Login</a>
            
        </div>

    </div>
</nav> -->

<!-- Hero Section with Carousel -->
<section class="hero-section">
    <div style="padding-left: 20px;">
         <app-header-latest></app-header-latest>
        <div id="heroCarousel" class="carousel slide container " data-bs-ride="carousel">
            <div class="carousel-inner">

                <div class="carousel-indicators">
                    <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="0" class="active"></button>
                    <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="1"></button>
                    <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="2"></button>
                    <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="3"></button>
                    <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="4"></button>
                    <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="5"></button>
                    <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="6"></button>
                </div>

                <!-- Slide 1 -->
                <div class="carousel-item active">
                    <div class="row align-items-center">
                        <div class="col-lg-6 hero-content">
                            <h1>A modern, next-generation platform connecting talent with opportunities.</h1>
                            <p>A modern, next-generation platform connecting talent with opportunities. Explore vacancies in various industries that match your skillsets.</p>
                            <a class="btn btn-gradient mt-3" (click)="goTo('/about-us')">
                                Learn More
                            </a>
                                                    </div>
                        <div class="col-lg-6 hero-img text-center">
                            <img src="assets/images/icon/Job hunt-amico 1.svg" class="img-fluid " alt="Web Design Image">
                        </div>
                    </div>
                </div>

                <!-- Slide 2 -->
                <div class="carousel-item">
                    <div class="row align-items-center">
                        <div class="col-lg-6 hero-content">
                            <h1>Designed to simplify hiring and job discovery.</h1>
                            <p>Recruitment marketplace for Talent Discovery & Career Growth. Recruiters' hiring spree makes this the sought after platform.</p>
                            <a href="#" class="btn btn-gradient mt-3">Explore Now</a>
                        </div>
                        <div class="col-lg-6 hero-img text-center">
                            <img src="assets/images/icon/Consulting-amico 1.svg" class="img-fluid " alt="Web Design Image">
                        </div>
                    </div>
                </div>

                 <!-- Slide 3 -->
                <div class="carousel-item">
                    <div class="row align-items-center">
                        <div class="col-lg-6 hero-content">
                            <h1>Connects skilled professionals with the right employers.</h1>
                            <p>Designed to simplify hiring and job discovery. Enhancing convenience for both employers and jobseekers.</p>
                            <a href="#" class="btn btn-gradient mt-3">Explore Now</a>
                        </div>
                        <div class="col-lg-6 hero-img text-center">
                            <img src="assets/images/icon/Interview-rafiki 1.svg" class="img-fluid " alt="Web Design Image">
                        </div>
                    </div>
                </div>

                 <!-- Slide 4 -->
                  <div class="carousel-item">
                    <div class="row align-items-center">
                        <div class="col-lg-6 hero-content">
                            <h1>Enables companies to hire top talent faster and smarter.</h1>
                            <p>Connects skilled professionals with the right employers. Bringing talent in all forms one-step closer to the employers.</p>
                            <a href="#" class="btn btn-gradient mt-3">Explore Now</a>
                        </div>
                        <div class="col-lg-6 hero-img text-center">
                            <img src="assets/images/icon/Online ads-amico 1.svg" class="img-fluid " alt="Web Design Image">
                        </div>
                    </div>
                </div>

                <!-- Slide 5 -->
                <div class="carousel-item">
                    <div class="row align-items-center">
                        <div class="col-lg-6 hero-content">
                            <h1>Recruitment marketplace for Talent Discovery & Career Growth.</h1>
                            <p>Enables companies to hire top talent faster and smarter. Saving companies' time, money and efforts immensely.</p>
                            <a href="#" class="btn btn-gradient mt-3">Explore Now</a>
                        </div>
                        <div class="col-lg-6 hero-img text-center">
                            <img src="assets/images/icon/Partnership-bro 1.svg" class="img-fluid " alt="Web Design Image">
                        </div>
                    </div>
                </div>

                <!-- Slide 6 -->
                <div class="carousel-item">
                    <div class="row align-items-center">
                        <div class="col-lg-6 hero-content">
                            <h1>The Future of Hiring is here and now !</h1>
                            <p>The Future of Hiring is here and now ! Know the right vacancies and apply for them on-the-go.
                            </p>
                            <a href="#" class="btn btn-gradient mt-3">Explore Now</a>
                        </div>
                        <div class="col-lg-6 hero-img text-center">
                            <img src="assets/images/icon/Jobs 1.svg" class="img-fluid " alt="Web Design Image">
                        </div>
                    </div>
                </div>

                <!-- Slide 7 -->
                <div class="carousel-item">
                    <div class="row align-items-center">
                        <div class="col-lg-6 hero-content">
                            <h1>Experience the hiring ecosystem like never before !</h1>
                            <p>Experience the hiring ecosystem like never before ! Unlocking smarter ways for smarter careers of tomorrow.</p>
                            <a href="#" class="btn btn-gradient mt-3">Explore Now</a>
                        </div>
                        <div class="col-lg-6 hero-img text-center">
                            <img src="assets/images/icon/Profile data-cuate 1.svg" class="img-fluid " alt="Web Design Image">
                        </div>
                    </div>
                </div>

            </div>

            <!-- Controls -->
            <button class="carousel-control-prev" type="button" data-bs-target="#heroCarousel" data-bs-slide="prev">
                <span class="carousel-control-prev-icon"></span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#heroCarousel" data-bs-slide="next">
                <span class="carousel-control-next-icon"></span>
            </button>

        </div>
    </div>
</section>

<section class="category-zone">
    <div class="container">
        <h2 class="category-title">Top Job Categories</h2>

        <div class="row">

            <!-- Technology -->
            <div class="col-lg-3 col-md-6 col-12">
                <div (click)="goTo('/available-jobs')" style="cursor: pointer;">
                    <img src="assets/images/icon/Frame 2085668991.svg" width="290px" height="179px" class="img-fluid" alt="Web Design Image">
                </div>
            </div>

            <!-- Marketing -->
            <div class="col-lg-3 col-md-6 col-12">
                <div (click)="goTo('/available-jobs')" style="cursor: pointer;">
                    <img src="assets/images/icon/Frame 2085668992.svg" width="290px" height="179px" class="img-fluid" alt="Web Design Image">
                </div>
            </div>

            <!-- Healthcare -->
            <div class="col-lg-3 col-md-6 col-12">
                <div (click)="goTo('/available-jobs')" style="cursor: pointer;">
                    <img src="assets/images/icon/Frame 2085668993.svg" width="290px" height="179px" class="img-fluid" alt="Web Design Image">
                </div>
            </div>

            <!-- Finance -->
            <div class="col-lg-3 col-md-6 col-12">
                <div (click)="goTo('/available-jobs')" style="cursor: pointer;">
                    <img src="assets/images/icon/Frame 2085668994.svg" width="290px" height="179px" class="img-fluid" alt="Web Design Image">
                </div>
            </div>

            <!-- Remote Work -->
            <!-- <div class="col-lg-20 col-md-4 col-6">
                <div class="category-box bg-remote" (click)="goTo('/available-jobs')" style="cursor: pointer;">
                    <div class="category-icon icon-remote">
                        <i class="bi bi-cast"></i>
                    </div>
                    <div>
                        <p class="cat-name">Remote Work</p>
                        <p class="cat-count">1,100 Jobs</p>
                    </div>
                </div>
            </div> -->

        </div>
    </div>
</section>


<section class="jobs-wrapper">
    <div class="container">
        <h2 class="jobs-heading">Featured Jobs</h2>

        <div class="row">

            <!-- Job Card 1 -->
            <div class="col-lg-4 col-md-6" *ngFor="let j of jobsList | slice:0:3">
                <div class="career-card">
                    <div class="job-top">
                        <img [src]="getAvatarImageUrl(j)" class="job-avatar">

                        <div>
                            <p class="job-title">{{j.job_title}}</p>
                            <p class="job-company">{{j.companyDetails.company_name}}</p>
                        </div>
                    </div>
                    <p class="job-info"><i class="bi bi-geo-alt"></i> {{ getCommaSeparatedLocations(j) }} • {{
                        formatSalary(j) }}</p>
                    <div class="text-end">
                        <button class="apply-btn-custom" (click)="goTo('/available-jobs')">Apply Now</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <section class="stats-section shadow-sm">
    <div class="container">
        <div class="row text-center g-4"> -->

            <!-- <div class="col-lg-3 col-md-6" *ngFor="let stat of stats">
                <div class="stat-box">
                    <div class="stat-icon" [ngClass]="stat.color">
                        <i class="bi" [ngClass]="stat.icon"></i>
                    </div>
                    <div class="stat-content text-start">
                        <h3>{{ stat.displayValue | number }}+</h3>
                        <p>{{ stat.label }}</p>
                    </div>
                </div>
            </div> -->

           
            <!-- <div class="col-lg-3 col-md-6">
                <div class="stat-box">
                    <div class="stat-icon purple">
                        <i class="bi bi-briefcase-fill"></i>
                    </div>
                    <div class="stat-content text-start">
                        <h3>10K+</h3>
                        <p>Jobs Posted</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="stat-box">
                    <div class="stat-icon orange">
                        <i class="bi bi-envelope-fill"></i>
                    </div>
                    <div class="stat-content text-start">
                        <h3>2K+</h3>
                        <p>Companies Hiring</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="stat-box">
                    <div class="stat-icon blue">
                        <i class="bi bi-check-circle-fill"></i>
                    </div>
                    <div class="stat-content text-start">
                        <h3>95%</h3>
                        <p>Success Rate</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="stat-box">
                    <div class="stat-icon violet">
                        <i class="bi bi-globe"></i>
                    </div>
                    <div class="stat-content text-start">
                        <h3>25</h3>
                        <p>Countries</p>
                    </div>
                </div>
            </div> -->

        <!-- </div>
    </div>
</section> -->

<!-- <section class="process-area">
    <div class="container">
        <h2 class="process-title">How It Works</h2>

        <div class="row g-4">
 -->
            <!-- Step 1 -->
            <!-- <div class="col-lg-4 col-md-6">
                <div class="step-card-box">
                    <div class="step-badge">1</div>
                    <div>
                        <h5 class="step-heading">Create Profile</h5>
                        <p class="step-text">Sign up and set up your profile.</p>
                    </div>
                </div>
            </div>
 -->
            <!-- Step 2 -->
            <!-- <div class="col-lg-4 col-md-6">
                <div class="step-card-box">
                    <div class="step-badge">2</div>
                    <div>
                        <h5 class="step-heading">Search Jobs</h5>
                        <p class="step-text">Find the perfect job that suits you.</p>
                    </div>
                </div>
            </div>
 -->
            <!-- Step 3 -->
            <!-- <div class="col-lg-4 col-md-6">
                <div class="step-card-box">
                    <div class="step-badge">3</div>
                    <div>
                        <h5 class="step-heading">Apply & Get Hired</h5>
                        <p class="step-text">Submit your application and get hired.</p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section> -->

<!-- <section class="brand-showcase-area">
    <div class="container">
        <h2 class="brand-heading">Featured Companies</h2>

        <div class="brand-logo-wrap">
            <div class="brand-item">
                <img src="https://static.wikia.nocookie.net/windows/images/3/33/Microsoft-logo.png"
                    alt="Microsoft">
            </div>


            <div class="brand-item">
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Amazon_logo.svg/3840px-Amazon_logo.svg.png"
                    alt="Amazon">
            </div>

            <div class="brand-item">
                <img src="https://upload.wikimedia.org/wikipedia/commons/6/69/Airbnb_Logo_Bélo.svg" alt="Airbnb">
            </div>

            <div class="brand-item">
                <img src="https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg" alt="Google">
            </div>
            <div class="brand-item">
                <img src="https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg" alt="Google">
            </div>

            <div class="brand-item">
                <img src="https://cdn.worldvectorlogo.com/logos/spotify-logo.svg" alt="Microsoft">
            </div>

        </div>

</section> -->
<!-- <section class="get-started-section">
    <div class="get-started-banner"></div>
</section> -->

<section class="faq">
    <div class="container">
        <div class="row align-items-center">

        <!-- Section Title -->
        <div class="col-lg-5">
        <div class="faq__left">

                    <h3 class="faq__title">
                        Frequently asked <br>
                        questions.
                    </h3>

                    <button class="faq__btn">
                        <span class="faq__icon">💬</span>
                        <span>Get to know us</span>
                    </button>

                    <div class="faq__image">
                        <img src="assets/images/accord-img.png" alt="FAQ Image">
                    </div>

                </div>
        </div>
        <div class="col-lg-7">
         <div class="accordion faq__accordion" id="faqAccordion">
      

  <div class="accordion-item faq-card" *ngFor="let faq of faqsList">
    <h2 class="accordion-header">
      <button
        class="accordion-button"
        type="button"
        data-bs-toggle="collapse"
        [attr.data-bs-target]="'#faq' + faq.id">

        {{ faq.title }}
      </button>
    </h2>

    <div
      [id]="'faq' + faq.id"
      class="accordion-collapse collapse"
      data-bs-parent="#faqAccord">

      <div class="accordion-body">
        {{ faq.description }}
      </div>
    </div>
  </div>

</div>

        <!-- Testimonials Row -->
        <!-- <div class="row g-4"> -->

            <!-- Card 1 -->
            <!-- <div class="col-md-6 col-lg-4">
                <div class="review-card-box">
                    <div class="d-flex align-items-center mb-3">
                        <img src="https://randomuser.me/api/portraits/women/44.jpg" class="client-avatar me-3" alt="">
                        <div>
                            <p class="client-review-text">
                                This platform helped me land my dream job.
                            </p>
                            <div class="star-rating">
                                <i class="bi bi-star-fill"></i>
                                <i class="bi bi-star-fill"></i>
                                <i class="bi bi-star-fill"></i>
                                <i class="bi bi-star-fill"></i>
                                <i class="bi bi-star-fill"></i>
                            </div>
                        </div>
                    </div>
                    <h6 class="client-name">Sarah M.</h6>
                    <span class="client-role">Marketing Manager</span>
                </div>
            </div> -->

            <!-- Card 2 -->
            <!-- <div class="col-md-6 col-lg-4">
                <div class="review-card-box">
                    <div class="d-flex align-items-center mb-3">
                        <img src="https://randomuser.me/api/portraits/men/32.jpg" class="client-avatar me-3" alt="">
                        <div>
                            <p class="client-review-text">
                                Amazing experience and great opportunities.
                            </p>
                            <div class="star-rating">
                                <i class="bi bi-star-fill"></i>
                                <i class="bi bi-star-fill"></i>
                                <i class="bi bi-star-fill"></i>
                                <i class="bi bi-star-fill"></i>
                                <i class="bi bi-star-fill"></i>
                            </div>
                        </div>
                    </div>
                    <h6 class="client-name">James R.</h6>
                    <span class="client-role">Software Engineer</span>
                </div>
            </div> -->

            <!-- Card 3 -->
            <!-- <div class="col-md-6 col-lg-4">
                <div class="review-card-box">
                    <div class="d-flex align-items-center mb-3">
                        <img src="https://randomuser.me/api/portraits/women/68.jpg" class="client-avatar me-3" alt="">
                        <div>
                            <p class="client-review-text">
                                I found my perfect job in just a few days!
                            </p>
                            <div class="star-rating">
                                <i class="bi bi-star-fill"></i>
                                <i class="bi bi-star-fill"></i>
                                <i class="bi bi-star-fill"></i>
                                <i class="bi bi-star-fill"></i>
                                <i class="bi bi-star-fill"></i>
                            </div>
                        </div>
                    </div>
                    <h6 class="client-name">Emily T.</h6>
                    <span class="client-role">UI/UX Designer</span>
                </div>
            </div>

        </div> -->

        <!-- Subscribe Button -->
        <!-- <div class="text-center mt-5">
            <button class="cta-subscribe-btn">
                Subscribe Now <i class="bi bi-arrow-right ms-2"></i>
            </button>
        </div> -->
        </div>
        </div>
    </div>
</section>

<app-footer-more-info></app-footer-more-info>

<!--<footer class="main-footer-area">
    <div class="container">
        <div class="row">

            Logo Section 
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="footer-logo-text">
                    <img src="/assets/images/NeoJobz_192_192-1.svg" width="200" height="50" alt="">
                </div>
                <p class="footer-tagline">
                    Connecting Team with Opportunity
                </p>
            </div>

            Quick Links 
            <div class="col-lg-2 col-md-6 mb-4">
                <h5 class="footer-title-text">Quick Links</h5>
                <a class="footer-link-style" (click)="goTo('/about-us')">About Us</a>
                <a href="#" class="footer-link-style">Career</a>
                <a href="#" class="footer-link-style">Press</a>
                <a class="footer-link-style" (click)="goTo('/blog')">Blog</a>
            </div>

             For Candidates
            <div class="col-lg-2 col-md-6 mb-4">
                <h5 class="footer-title-text">For Candidates</h5>
                <a href="#" class="footer-link-style">Browse Jobs</a>
                <a href="#" class="footer-link-style">Job Alerts</a>
                <a href="#" class="footer-link-style">Career Tips</a>
            </div>

            For Employers
            <div class="col-lg-2 col-md-6 mb-4">
                <h5 class="footer-title-text">For Employers</h5>
                <a href="#" class="footer-link-style">Post a Job</a>
                <a href="#" class="footer-link-style">Hire Talent</a>
                <a class="footer-link-style" (click)="goTo('/pricing')">Pricing</a>
            </div>

            Support
            <div class="col-lg-3 col-md-6 mb-4">
                <h5 class="footer-title-text">Support</h5>
                <a class="footer-link-style" (click)="goTo('/contact-us')">Contact Us</a>
                <a href="#" class="footer-link-style">Help Center</a>
                <a class="footer-link-style" (click)="goTo('/terms-and-conditions')">Terms & Conditions</a>

                <div class="footer-social-icons mt-3">
                    <a href="https://www.facebook.com/whiterobein"><i class="fa-brands fa-facebook-f"></i></a>
                    <a href="https://twitter.com/whiterobein"><i class="bi bi-twitter-x"></i></a>
                    <a href="https://instagram.com/whiterobein"><i class="bi bi-instagram"></i></a>
                    <a href="https://linkedin.com/company/whiterobein"><i class="bi bi-linkedin"></i></a>
                    <a href="https://www.youtube.com/@whiterobein"><i class="bi bi-youtube"></i></a>
                </div>
            </div>

        </div>
    </div>

    Bottom Copyright
    <div class="footer-bottom-bar">
          © {{ currentYear }}  All rights reserved. | <a href="/privacy" class="footer-bottom-link">Privacy Policy</a> | <a href="/terms-and-conditions" class="footer-bottom-link">Terms and Conditions</a> | <a href="/pricing-policy" class="footer-bottom-link">Pricing Policy</a> | <a href="/refund-policy" class="footer-bottom-link">Refund Policy</a> | <a href="/cancellation-policy" class="footer-bottom-link">Cancellation Policy</a>
    </div>

</footer>-->

<!-- <footer class="site-footer-area">
    <div class="container">

        <div class="row">

            Column 1 
            <div class="col-md-6 col-lg-3 mb-4">
                <h5 class="footer-heading-title">About Us</h5>
                <a class="footer-link-item" (click)="goTo('/about-us')">About US</a>
                <a class="footer-link-item" (click)="goTo('/contact-us')">Contact</a>
                <a href="#" class="footer-link-item">Connect Us</a>
                <a href="#" class="footer-link-item">Blog</a>
                
            </div>

             Column 2 
            <div class="col-md-6 col-lg-3 mb-4">
                <h5 class="footer-heading-title">For Candidates</h5>
                <a href="#" class="footer-link-item">Browse Jobs</a>
                <a href="#" class="footer-link-item">Jobs Near Me</a>
                <a href="#" class="footer-link-item">Remote Jobs</a>
                <a href="#" class="footer-link-item">Match Jobs</a>
            </div>

             Column 3 
            <div class="col-md-6 col-lg-3 mb-4">
                <h5 class="footer-heading-title">For Employers</h5>
                <a href="#" class="footer-link-item">Post Jobs</a>
                <a href="#" class="footer-link-item">Browse Resumes</a>
                <a href="#" class="footer-link-item">Hire Now</a>
            </div>

             Column 4 
            <div class="col-md-6 col-lg-3 mb-4">
                <h5 class="footer-heading-title">Support</h5>
                <a href="#" class="footer-link-item">Candidate Help</a>
                <a href="#" class="footer-link-item">Employer Help</a>
                <a href="#" class="footer-link-item">Blog Center</a>

                <div class="social-icons-group mt-3">
                    <a href="#"><i class="bi bi-facebook"></i></a>
                    <a href="#"><i class="bi bi-twitter"></i></a>
                    <a href="#"><i class="bi bi-instagram"></i></a>
                    <a href="#"><i class="bi bi-linkedin"></i></a>
                </div>
            </div>

        </div>

        Bottom 
        <div class="footer-bottom-text">
            © {{ currentYear }} All rights reserved. | <a href="/privacy" class="footer-bottom-link">Privacy Policy</a> | <a href="/terms-and-conditions" class="footer-bottom-link">Terms and Conditions</a> | <a href="/pricing-policy" class="footer-bottom-link">Pricing Policy</a> | <a href="/refund-policy" class="footer-bottom-link">Refund Policy</a> | <a href="/cancellation-policy" class="footer-bottom-link">Cancellation Policy</a>
        </div>

    </div>
</footer> -->

<!-- Bootstrap JS -->
<!-- <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script> -->

<!-- </body>

</html> -->